import SellerInfo from './SellerInfo.component';

export default SellerInfo;
